import {
  PadelSetScore,
  PickleballGameScore,
  Sport,
} from "@/types";
import React from "react";
import PadelMatchResultForm, {
  defaultPadelSets,
} from "./PadelMatchResultForm";
import PickleballMatchResultForm, {
  defaultPickleballGames,
} from "./PickleballMatchResultForm";

export type MatchResultFormValue =
  | { sport: "padel"; sets: PadelSetScore[] }
  | { sport: "pickleball"; games: PickleballGameScore[] };

export function defaultMatchResultValue(
  sport: Sport["slug"],
): MatchResultFormValue {
  if (sport === "pickleball") {
    return { sport: "pickleball", games: defaultPickleballGames };
  }
  return { sport: "padel", sets: defaultPadelSets };
}

export interface MatchResultFormProps {
  sport: Sport["slug"];
  value: MatchResultFormValue;
  onChange: (next: MatchResultFormValue) => void;
  disabled?: boolean;
  team1Name?: string;
  team2Name?: string;
  team1Id?: string;
  team2Id?: string;
}

const MatchResultForm: React.FC<MatchResultFormProps> = ({
  sport,
  value,
  onChange,
  disabled,
  team1Name,
  team2Name,
  team1Id,
  team2Id,
}) => {
  if (sport === "pickleball") {
    const games =
      value.sport === "pickleball" ? value.games : defaultPickleballGames;
    return (
      <PickleballMatchResultForm
        value={{ games }}
        onChange={(next) =>
          onChange({ sport: "pickleball", games: next.games })
        }
        disabled={disabled}
        team1Name={team1Name}
        team2Name={team2Name}
        team1Id={team1Id}
        team2Id={team2Id}
      />
    );
  }

  const sets = value.sport === "padel" ? value.sets : defaultPadelSets;
  return (
    <PadelMatchResultForm
      value={{ sets }}
      onChange={(next) => onChange({ sport: "padel", sets: next.sets })}
      disabled={disabled}
      team1Name={team1Name}
      team2Name={team2Name}
      team1Id={team1Id}
      team2Id={team2Id}
    />
  );
};

export default MatchResultForm;
